import React from 'react';
import PropTypes from 'prop-types';
import { FormHelperText } from '@material-ui/core';
import Translator from '%app/js/common/services/translator';

import withTranslationsErrorMapper from './withTranslationsErrorMapper';

const ErrorMapper = ({ errors }) => (
    <React.Fragment>
        {errors.map((errorText, key) => (
            <FormHelperText key={key} error component="div">
                <span
                    dangerouslySetInnerHTML={{
                        __html: Translator.trans(errorText),
                    }}
                />
            </FormHelperText>
        ))}
    </React.Fragment>
);

ErrorMapper.propTypes = {
    errors: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ErrorMapper;
export const TranslationsErrorMapper = withTranslationsErrorMapper(ErrorMapper);
